import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../lib/i18n";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (admin) navigate("/admin"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Error";
      toast.error(typeof msg === "string" ? msg : "Error");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex w-14 h-14 items-center justify-center border border-[#C5A059]/30 mb-6">
            <Lock size={20} className="text-[#C5A059]" />
          </div>
          <h1 className="font-serif-display text-4xl text-white mb-2">{t(lang, "admin_login")}</h1>
        </div>
        <form onSubmit={submit} className="space-y-8 bg-[#111822] border border-[#C5A059]/15 p-10">
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-[#C5A059] mb-2 block">{t(lang, "admin_email")}</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="editorial-input w-full py-3" data-testid="admin-email" />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-[#C5A059] mb-2 block">{t(lang, "admin_password")}</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="editorial-input w-full py-3" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-[#C5A059] text-[#0A0F16] py-4 text-sm tracking-[0.2em] uppercase font-medium hover:bg-[#E5C07B] transition-colors disabled:opacity-50"
            data-testid="admin-submit">
            {loading ? "..." : t(lang, "admin_enter")}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
